import {applySpec, get} from '@yandex-delivery/utils'

import type {Order, SameDayData} from 'src/shared/types'

export const fromSddExpressDeliveryInterval: (order: Order) => SameDayData = applySpec<SameDayData>({
  delivery_interval: get('sdd.deliveryInterval'),
})
